import { supabase } from "../supabase/SupabaseClient";
import { FLOTABOT } from "../components/layout/secciones";

/* Las guías que le tocan a quien está mirando el hub. Para «¿Cómo se usa?».
 *
 * LA LISTA LA RECORTA FLOTABOT, NO ESTA PANTALLA. El hub tiene los permisos en
 * memoria y podría filtrar solo, pero para eso tendría que recibir la lista
 * entera con la llave de cada guía — y la lista entera, en la pestaña de red
 * de cualquiera, es lo que no se quiere. Acá llega lo de cada uno y nada más.
 *
 * El mail no se manda: sale del token, igual que en `guiaDelBot`.
 *
 * `verComoMail` es la vista previa del armazón. Del otro lado sólo vale para
 * la cuenta que ya lo ve todo; para cualquier otra se ignora.
 *
 * Devuelve la lista, o `null` si no se pudo preguntar.
 */
export async function guiasDelSector(verComoMail = null) {
  try {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    if (!token) return null;

    const q = verComoMail
      ? "?ver_como=" + encodeURIComponent(verComoMail)
      : "";
    const r = await fetch(`${FLOTABOT}/como/sector${q}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!r.ok) return null;

    const j = await r.json();
    if (!j || !Array.isArray(j.guias)) return null;
    // Una guía sin título o sin dirección dibujaría un renglón que no lleva a
    // ningún lado: se descarta acá y no en la pantalla.
    return j.guias.filter((g) => g && g.titulo && g.url);
  } catch (e) {
    return null;
  }
}
